import React, { useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { SentimentDissatisfied } from "@mui/icons-material";
import chaletApi from "api/chaletApi";
import { Sector } from "types/Sector";
import dayjs from "dayjs";
import { CardActiveOrders } from "../DeliveriesTab/CardActiveOrders";

type OrdersProps = {
  sector: Sector;
};

export const Orders: React.FC<OrdersProps> = ({ sector }) => {
  const [getOrdersByCurrentDayInSector, result] = chaletApi.useLazyGetOrdersByCurrentDayInSectorQuery();

  useEffect(() => {
    getOrdersByCurrentDayInSector(sector.id);
  }, [sector]);

  const todayOrders = result.data
    ?.filter((order: any) => dayjs(order.createdAt).isSame(dayjs(), "day"))
    .sort((a: any, b: any) => dayjs(b.createdAt).valueOf() - dayjs(a.createdAt).valueOf());

  if (todayOrders && todayOrders.length > 0) {
    return (
      <Box p={2} flexGrow={1} display="flex" flexDirection="column">
        <Box
          sx={{
            maxHeight: "80vh",
            overflowY: "auto",
            padding: 2,
            border: "1px solid #ddd",
            borderRadius: "8px",
          }}
        >
          <Grid container spacing={3}>
            {todayOrders.map((order: any) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={order.id}>
                <CardActiveOrders order={order} />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        width: "100%",
        height: "50vh",
        textAlign: "center",
      }}
    >
      <SentimentDissatisfied sx={{ fontSize: 60, color: "gray" }} />
      <Typography variant="h6" color="textSecondary">
        No active orders for today
      </Typography>
    </Box>
  );
};
